import { useMutation } from '@tanstack/react-query';
import { ApiError, BaseResponseType, apiClient } from 'shared/api';

const postVerifyCode = async ({ email, code }: { email: string; code: string }): Promise<BaseResponseType<string>> => {
  const { data } = await apiClient.post('/auth/member/verify-code', { email, code });

  // NOTE: 현재 실패한 요청에도 http code를 200으로 받고 있기 때문에 아래와 같이 처리합니다
  if (!data.isSuccess) {
    throw new ApiError(data);
  }

  return data.result;
};

export const usePostVerifyCode = ({
  onSuccess,
  onError,
}: {
  onSuccess: () => void;
  onError: (error: string) => void;
}) => {
  return useMutation({
    mutationFn: postVerifyCode,

    onSuccess: () => {
      onSuccess();
    },

    onError: (error) => {
      if (error instanceof ApiError) {
        onError && onError(error.message);
      }
    },
  });
};
